/* Backdrop — semi-transparent overlay with blur */
.backdrop {
  position: fixed;
  inset: 0;
  z-index: 90;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
}
.backdrop[data-open='true'] {
  opacity: 1;
  pointer-events: auto;
}

/* Drawer panel — slides in from the right */
.drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 800px;
  max-width: 100vw;
  z-index: 100;
  background: var(--bg-surface);
  border-left: 1px solid var(--border-subtle);
  box-shadow: -8px 0 32px rgba(0, 0, 0, 0.3);
  transform: translateX(100%);
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    width 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Map parrot-chat tokens onto this app's design system (canonical
     @parrot/tokens vars). The periwinkle --ai-* family (styles/themes.css) is
     this product's assistant accent, so the chat surface reads as "the machine
     did this" without competing with crimson/gold. */
  --parrot-chat-bg: var(--bg-surface);
  --parrot-chat-surface: var(--bg-card);
  --parrot-chat-border: var(--border-subtle);
  --parrot-chat-text: var(--text-primary);
  --parrot-chat-text-muted: var(--text-muted);
  --parrot-chat-accent: var(--ai-accent, var(--accent-primary));
  --parrot-chat-user-bubble: var(--ai-gradient, var(--accent-primary));
  --parrot-chat-user-bubble-hover: var(--ai-gradient-flip, var(--accent-primary-hover));
  --parrot-chat-radius: var(--radius-md);
  --parrot-chat-font-family: var(--font-sans);
  --parrot-chat-font-weight-normal: var(--weight-regular);
  --parrot-chat-font-weight-medium: var(--weight-medium);
  --parrot-chat-font-weight-bold: var(--weight-bold);
  --parrot-chat-sidebar-width: 240px;
}

.drawer[data-open='true'] {
  transform: translateX(0);
}

/* Fullscreen — cover the entire viewport, including the app sidebar. */
.drawer[data-fullscreen='true'] {
  width: 100vw;
  left: 0;
  border-left: none;
  box-shadow: none;
  z-index: 9999;
}

/* Responsive — full width on narrow viewports. */
@media (max-width: 840px) {
  .drawer {
    width: 100vw;
    --parrot-chat-sidebar-width: 200px;
  }
}
